import { printSelectorStatsTable } from 'projects/semeris/src/store/create-memoized-selector';

import { DateHelper } from './date-helper';
import { printExecutionStatsTable } from './runtime-function-stats';
import { printReducerStatsTable } from './runtime-reducer-stats';

export function registerRuntimeStats() {
  window['semerisRuntimeStats'] = {};
  window['semerisRuntimeStats']['selectors'] = (key?: string) => printSelectorStatsTable(key);
  window['semerisRuntimeStats']['functions'] = (key?: string) => printExecutionStatsTable(key);
  window['semerisRuntimeStats']['reducers'] = (key?: string) => printReducerStatsTable(key);
  window['semerisRuntimeStats']['dateCacheSize'] = () => DateHelper.runtimeStatistics();
}

/*
  Event listener stats

  This will only work in Chrome DevTools because "getEventListeners" is not standard.

  Just copy paste to the console to use it.


function countEventListenersByType() {
  const allElements = document.querySelectorAll('*');
  const eventTypeCounts = {};

  // Helper function to count listeners by type
  function addListenersByType(element) {
      const listeners = getEventListeners(element);
      Object.keys(listeners).forEach(type => {
          eventTypeCounts[type] = (eventTypeCounts[type] || 0) + listeners[type].length;
      });
  }

  // Count listeners on each element in the DOM
  allElements.forEach(element => addListenersByType(element));

  // Count listeners on top-level objects: window, document, and body
  const topLevelElements = [window, document, document.body];
  topLevelElements.forEach(element => addListenersByType(element));

  // Calculate the total number of listeners
  const totalListeners = Object.values(eventTypeCounts).reduce((sum, count) => sum + count, 0);

  // Display the results as a table in the console, with event types as index
  console.table(eventTypeCounts);

  // Print the total
  console.log(`Total Event Listeners: ${totalListeners}`);
}



countEventListenersByType();

*/
